import React from "react";
import { useTranslation, Trans } from "react-i18next";
import {
  BasicRulesContainer,
  ColumnTitle,
  ColumnDescription,
  InfoBox,
  InfoBoxTitle,
  InfoBoxDescription,
} from "./BasicRules.styled";
import { Container } from "react-bootstrap";
import VideoSection from "../VideoBackground/VideoBackground";

const BasicRules = ({ id = "basic-rules" }) => {
  const { t } = useTranslation();

  return (
    <BasicRulesContainer id={id}>
      <Container>
        <div className="row mb-4">
          <div className="col-md-6 mb-4 mb-md-0">
            <ColumnTitle>{t("basicRules.leftColumn.title")}</ColumnTitle>
            <ColumnDescription>
              {t("basicRules.leftColumn.description")}
            </ColumnDescription>
          </div>
          <div className="col-md-6">
            <ColumnTitle>{t("basicRules.rightColumn.title")}</ColumnTitle>
            <ColumnDescription>
              <Trans>{t("basicRules.rightColumn.description")}</Trans>
            </ColumnDescription>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mt-4 mb-5">
            <InfoBox className="p-4">
              <InfoBoxTitle>{t("basicRules.infoBox.title")}</InfoBoxTitle>
              <InfoBoxDescription>
                {t("basicRules.infoBox.description")}
              </InfoBoxDescription>
            </InfoBox>
          </div>
        </div>
      </Container>
      <VideoSection />
    </BasicRulesContainer>
  );
};

BasicRules.defaultProps = {
  id: "basic-rules",
};

export default BasicRules;
